<template>
  <div class="sidebar">
    <div class="stock_title">ຮຸ້ນ</div>
    <div class="stock_chart">
      <table class="table table-sm table-bordered">
        <thead>
          <tr>
            <th>ຊື່ຫຼັກຊັບ</th>
            <th width="30%">ລາຄາປະຈຸບັນ</th>
            <th width="20%">ປ່ຽນແປງ</th>
            <th width="20%">ປະລິມານ</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ທຄຕລ</td>
            <td>4,190</td>
            <td>0</td>
            <td>2,300</td>
          </tr>
          <tr>
            <td>ຜ-ຟຟລ</td>
            <td>1,980</td>
            <td>180</td>
            <td>2,100</td>
          </tr>
          <tr>
            <td>ມຫທຊ</td>
            <td>440</td>
            <td>20</td>
            <td>56,400</td>
          </tr>

          <tr>
            <td>ປທລ</td>
            <td>1,150</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>ສ.ວ.ນ</td>
            <td>2,800</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>ພກພ <span class="badge badge-danger">Alert</span></td>
            <td>1,370</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>ບຊລ <span class="badge badge-danger">H</span></td>
            <td>1,090</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>ລອທ</td>
            <td>840</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>ວຈຊຕ</td>
            <td>900</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>ລອຊ <span class="badge badge-warning">NCD</span></td>
            <td>23,000</td>
            <td>0</td>
            <td>0</td>
          </tr>
        </tbody>
      </table>

      <div class="stock_note">
        <span class="badge badge-danger">H</span> = ໂຈະການຊື້ ຂາຍຮຸ້ນ<br />
        <span class="badge badge-danger">Alert</span> = ການແຈ້ງເຕືອນຄັ້ງທີ່ 1 ກ່ຽວກັບການຮັກສາສະຖານະ ຂອງບໍລິສັດຈົດທະບຽນ<br />
        <span class="badge badge-warning">NCD</span> = ບໍ່ສາມາດເປີດເຜີຍຂໍ້ມູນທັນຕາມກຳນົດ
      </div>
    </div>

    <div class="stock_title mt-3">ບໍລິສັດຈົດທະບຽນ</div>
    <div class="stock_chart">
      <table class="table table-list-com table-sm table-bordered">
        <thead>
          <tr>
            <th>ຊື່ຫຼັກຊັບ</th>
            <th width="26%">ຈໍານວນຮຸ້ນ<br />ຈົດທະບຽນ</th>
            <th width="26%">ມູນຄ່າຕະຫຼາດ<br />(ລ້ານກີບ)</th>
            <th width="26%">% ຕໍ່<br />ມູນຄ່າລວມ</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ທຄຕລ</td>
            <td>207,723,300</td>
            <td>870,360.63</td>
            <td>6.62%</td>
          </tr>
          <tr>
            <td>ຜ-ຟຟລ</td>
            <td>1,679,303,697</td>
            <td>3,022,746.65</td>
            <td>22.99%</td>
          </tr>
          <tr>
            <td>ປທລ</td>
            <td>235,000,000</td>
            <td>270,250.00</td>
            <td>2.06%</td>
          </tr>
          <tr>
            <td>ສ.ວ.ນ</td>
            <td>165,000,000</td>
            <td>462,000.00</td>
            <td>3.51</td>
          </tr>
          <tr>
            <td>ພກພ</td>
            <td>582,000,000</td>
            <td>797,340.00</td>
            <td>6.07%</td>
          </tr>
          <tr>
            <td>ບຊລ</td>
            <td>40,004,000</td>
            <td>43,604.36</td>
            <td>0.33%</td>
          </tr>
          <tr>
            <td>ມຫທຊ</td>
            <td>400,000,000</td>
            <td>168,000.00</td>
            <td>1.28%</td>
          </tr>
          <tr>
            <td>ລອທ</td>
            <td>100,000,000</td>
            <td>84,000.00</td>
            <td>0.64%</td>
          </tr>
          <tr>
            <td>ວຈຊຕ</td>
            <td>147,199,900</td>
            <td>132,479.91</td>
            <td>1.01%</td>
          </tr>
          <tr>
            <td>ລອຊ</td>
            <td>301,500,000</td>
            <td>6,934,500.00</td>
            <td>52.75%</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th class="text-center" colspan="4">
              ມູນຄ່າຕະຫຼາດລວມ:  13,145,285.82
            </th>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Sidebar'
}
</script>
<style lang="scss" scoped>
.sidebar {
  .stock_title {
    font-size: 110%;
    font-weight: bold;
  }

  .stock_chart {
    table {
      border-left: 0;
      border-right: 0;

      thead {
        background-color: #EBEBEB;

        tr {
          th {
            padding: 4px 0;
            font-size: 80%;
            text-align: center;
          }
        }
      }

      tbody {
        tr {
          td {
            padding: 2px 4px;
            text-align: right;
            font-size: 80%;
            vertical-align: middle;
            border-left: 0;
            border-right: 0;

            .badge {
              border-radius: 8px;
              font-size: 75%;
              padding: 2px 8px;
              color: #FFFFFF;
            }
          }

          td:first-child {
            text-align: left;
            font-size: 90%;
          }
        }
      }
    }

    .table-list-com {
      tbody {
        tr {
          td {
            padding: 4px 2px;
          }
        }
      }

      tfoot {
        background-color: #EBEBEB;
        border-bottom: 3px double #dee2e6;
      }
    }

    .stock_note {
      font-size: 85%;
    }
  }
}
</style>
